// Export action types for auth flow
export const LOGIN_PROCESS_STARTED = 'LOGIN_PROCESS_STARTED'
export const LOGIN_PROCESS_COMPLETED = 'LOGIN_PROCESS_COMPLETED'
export const UPDATE_TOKEN = 'UPDATE_TOKEN'
export const LOGIN_PROCESS_FAIL = 'LOGIN_PROCESS_FAIL'
export const LOGIN_PROCESS_FINISHED = 'LOGIN_PROCESS_FINISHED'

// Export action types for bot and greet flow
export const SET_OBJECTIVE = 'SET_OBJECTIVE'
export const INIT_BOT_DATA = 'INIT_BOT_DATA'
export const FETCH_BOT_DATA_SUCCESS = 'FETCH_BOT_DATA_SUCCESS'
export const FETCH_BOT_DATA_FAIL = 'FETCH_BOT_DATA_FAIL'
export const INIT_UPDATE_BOT_DATA = 'INIT_UPDATE_BOT_DATA'
export const UPDATE_BOT_DATA_SUCCESS = 'UPDATE_BOT_DATA_SUCCESS'
export const UPDATE_BOT_DATA_FAIL = 'UPDATE_BOT_DATA_FAIL'
export const INIT_USER_GREET = 'INIT_USER_GREET'
export const FETCH_USER_GREET_SUCCESS = 'FETCH_USER_GREET_SUCCESS'
export const FETCH_USER_GREET_FAIL = 'FETCH_USER_GREET_FAIL'
export const INIT_UPDATE_USER_GREET_DATA = 'INIT_UPDATE_USER_GREET_DATA'
export const UPDATE_USER_GREET_DATA_SUCCESS = 'UPDATE_USER_GREET_DATA_SUCCESS'
export const UPDATE_USER_GREET_DATA_FAIL = 'UPDATE_USER_GREET_DATA_FAIL'

// Update knowledge
export const UPDATE_KNOWLEDGE_BY_ID_SUCCESS = 'UPDATE_KNOWLEDGE_BY_ID_SUCCESS'

// Local greeting update
export const LOCAL_GREETING_BUTTONS_UPDATE = 'LOCAL_GREETING_BUTTONS_UPDATE'
